<!-- 生日汇 首页 -->

<template>
  <div class="birthday-page">
    <div class="content-box">
      <city-select :cate-id="0" :include-cate-ids="[3, 4]"></city-select>

      <div class="body-box">
        <ads-images :ad-id="44"></ads-images>

        <div class="box3 mt10">
          <van-tabs v-model="active">
            <van-tab title="蛋糕糕点">
              <van-swipe class="my-swipe" @change="onChange($event, 0)">
                <van-swipe-item v-for="item in cakeBrand.pages" :key="item">
                  <van-grid :border="false" :column-num="4">
                    <van-grid-item v-for="item in cakeBrand.records" :key="item.brandId"
                      :to="{ path: 'brand-detail', query: { brandId: item.brandId } }">
                      <van-image :src="item.headImage" height="36" round width="36"></van-image>
                      <div style="font-size: 12px;color: #666666">{{ item.name }}</div>
                    </van-grid-item>
                  </van-grid>
                </van-swipe-item>
              </van-swipe>
            </van-tab>

            <van-tab title="电子券">
              <van-swipe class="my-swipe" @change="onChange($event, 1)">
                <van-swipe-item v-for="item in ticketBrand.pages" :key="item">
                  <van-grid :border="false" :column-num="4">
                    <van-grid-item v-for="item in ticketBrand.records" :key="item.brandId"
                      :to="{ path: 'brand-detail', query: { brandId: item.brandId } }">
                      <van-image :src="item.headImage" height="36" round width="36"></van-image>
                      <div style="font-size: 12px;color: #666666">{{ item.name }}</div>
                    </van-grid-item>
                  </van-grid>
                </van-swipe-item>
              </van-swipe>
            </van-tab>

            <van-tab title="休闲零食">
              <van-swipe class="my-swipe" @change="onChange($event, 2)">
                <van-swipe-item v-for="item in snacksBrand.pages" :key="item">
                  <van-grid :border="false" :column-num="4">
                    <van-grid-item v-for="item in snacksBrand.records" :key="item.brandId"
                      :to="{ path: 'brand-detail', query: { brandId: item.brandId } }">
                      <van-image :src="item.headImage" height="36" round width="36"></van-image>
                      <div style="font-size: 12px;color: #666666">{{ item.name }}</div>
                    </van-grid-item>
                  </van-grid>
                </van-swipe-item>
              </van-swipe>
            </van-tab>
          </van-tabs>
        </div>

        <div class="box4 mt12 flex-row row-between">
          <div class="left-box">
            <div
              style="width: 85px;height: 23px;background: #D3273C;border-radius: 5px 0px 10px 0px;color: white;font-size: 12px;text-align: center;line-height: 23px">
              <span class="iconfont icon-aixin_shixin"></span>
              蛋糕推荐
            </div>
            <div class="flex-row row-between" style="padding: 5px">
              <goods-unit v-for="item in recommendCakeList" :key="item.goodsId" :goods-id="item.goodsId"
                :goods-style="6" :head-image="item.headImage" :name="item.name" :price="item.price" :spec="item.spec"
                class="mt3" style="width: 73px;height: 100px;background: #FFFFFF;border-radius: 5px;">
              </goods-unit>
            </div>
          </div>

          <div class="right-box">
            <div
              style="width: 85px;height: 23px;background: #FFB414;border-radius: 5px 0px 10px 0px;color: white;font-size: 12px;text-align: center;line-height: 23px">
              <span class="iconfont icon-aixin_shixin"></span>
              电子券推荐
            </div>
            <div class="flex-row row-between" style="padding: 5px">
              <goods-unit v-for="item in recommendTicketList" :key="item.goodsId" :goods-id="item.goodsId"
                :goods-style="6" :head-image="item.headImage" :name="item.name" :price="item.price" :spec="item.spec"
                class="mt3" style="width: 73px;height: 100px;background: #FFFFFF;border-radius: 5px;">
              </goods-unit>
            </div>
          </div>
        </div>

        <div v-for="item in goodsByBrandList.records" :key="item.brandId" class="box5 mt14">
          <div style="padding: 15px">
            <div class="flex-row">
              <img :src="item.headImage" alt="" style="width: 44px;height: 44px">
              <div style="width: 280px;margin-left: 4px">
                <div class="flex-row row-between">
                  <div style="font-size: 17px;color: #1A1A1A;">
                    {{ item.name }}
                  </div>
                  <div class="flex-row col-center" style="font-size: 14px;color: #979797;">
                    <span><router-link :to="{ path: 'brand-detail', query: { brandId: item.brandId } }"
                        style="color: #979797;">更多</router-link></span>
                    <van-icon name="arrow" />
                  </div>
                </div>
                <div class="mt4" style="font-size: 12px;color: #343434;">
                  {{ item.detail }}
                </div>
              </div>
            </div>
            <div class="goods-box flex-row row-between flex-wrap">
              <goods-unit v-for="g in item.goodsList" :key="g.goodsId" :goods-id="g.goodsId" :goods-style="7"
                :head-image="g.headImage" :name="g.name" :original-price="g.originalPrice" :price="g.price"
                :spec="g.spec" class="goods-item" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <PageFooter :active="0"></PageFooter>
  </div>
</template>

<script>
import { GOODS_CATE_INFO } from "@/api/constant";
import { api_get_brands_by_cate_id, api_get_goods_list_by_tag } from "@/api/goods-api";
import AdsImages from "@/components/common/ads-images";
import CitySelect from "@/components/common/city-select";
import GoodsUnit from "@/components/common/goods-unit";
import PageFooter from "@/components/common/page-footer";
import { change_city_by_location } from "@/util/LocationUtil";
import { wx_get_location_cached } from "@/util/wxSdk";
import { Lazyload } from "vant";
import Vue from "vue";

Vue.use(Lazyload);

export default {
  name: "index",
  components: { PageFooter, AdsImages, GoodsUnit, CitySelect },

  data() {
    return {
      search: {
        city: 0,
        keyword: ''
      },
      cityList: [
        { text: '成都', value: 0 },
        { text: '德阳', value: 1 },
        { text: '绵阳', value: 2 },
      ],
      active: '',
      cakeBrand: [],
      ticketBrand: [],
      adImageList: [],//轮播图
      recommendCakeList: [],
      recommendTicketList: [],
      goodsByBrandList: [],

      cakeCateId: GOODS_CATE_INFO.cake.id, // 蛋糕
      ticketCateId: GOODS_CATE_INFO.ticket.id, // 电子券
      snacksCateId: 678,  // 食品零食

      snacksBrand: [],
      recommendSnacksList: [],
    }
  },

  mounted() {
    budo_log.info("#171 birthday mounted")

    wx_get_location_cached(() => {
      var lat = sessionStorage.getItem("USER_CURRENT_POI_LAT");
      var lng = sessionStorage.getItem("USER_CURRENT_POI_LNG");

      budo_log.debug("#175 get_user_poi_location", lat, lng)

      // 如果定位位置和选择的位置不同 就提醒用户切换
      change_city_by_location(lat, lng)
    })
  },

  created() {
    budo_log.debug("#185 birthday created")
    api_get_brands_by_cate_id(this.cakeCateId, 0, 1, 8).then(res => {
      this.cakeBrand = res.data;
    })

    api_get_brands_by_cate_id(this.ticketCateId, 0, 1, 8).then(res => {
      this.ticketBrand = res.data;
    })

    api_get_brands_by_cate_id(this.snacksCateId, 0, 1, 8).then(res => {
      budo_log.debug("#196 api_get_brands_by_cate_id", res)
      this.snacksBrand = res.data;
    })

    api_get_brands_by_cate_id(this.cakeCateId, 3, 1, 20).then(res => {
      this.goodsByBrandList = res.data;
    })

    api_get_goods_list_by_tag(this.$store.getters.city_code, '推荐', this.cakeCateId, 1, 2).then(res => {
      this.recommendCakeList = res?.data?.records;
    })

    api_get_goods_list_by_tag(this.$store.getters.city_code, '推荐', this.ticketCateId, 1, 2).then(res => {
      this.recommendTicketList = res?.data?.records;
    })
  },

  methods: {
    onChange(index, type) {
      if (type === 0) {
        api_get_brands_by_cate_id(this.cakeCateId, 0, index + 1, 8).then(res => {
          this.cakeBrand = res.data;
        })
      } else if (type === 1) {
        api_get_brands_by_cate_id(this.ticketCateId, 0, index + 1, 8).then(res => {
          this.ticketBrand = res.data;
        })
      } else if (type === 2) {
        api_get_brands_by_cate_id(this.snacksCateId, 0, index + 1, 8).then(res => {
          this.snacksBrand = res.data;
        })
      }
    },

    forbidBack() {
      window.history.pushState('forward', null, '#');
      window.history.forward(1);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "index";
</style>
